'use strict';

var kea = require('kea');

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/* usage:
kea({
  listeners: ({ actions, values, store, sharedListeners }) => ({
    [actions.openUrl]: ({ url }, breakpoint, action) => { actions.urlOpened(url) },
    [LOCATION_CHANGE]: [
      (payload, breakpoint, action) => { store.dispatch(...) },
      sharedListenres.otherListeForTheSameAction
    ]
  })
})
*/

var index = {
  name: 'listeners',
  defaults: function defaults() {
    return {
      listeners: undefined,
      sharedListeners: undefined
    };
  },
  buildOrder: {
    listeners: {
      before: 'events'
    },
    sharedListeners: {
      before: 'listeners'
    }
  },
  buildSteps: {
    listeners: function listeners(logic, input) {
      if (!input.listeners) {
        return;
      }

      logic.cache.listenerBreakpointCounter = {};

      var fakeLogic = _extends({}, logic);

      Object.defineProperty(fakeLogic, 'store', {
        get: function get() {
          return kea.getContext().store;
        }
      });
      var newListeners = input.listeners(fakeLogic);
      logic.listeners = _extends({}, logic.listeners || {});

      var _loop = function _loop() {
        var key = _Object$keys[_i];
        var newArray = Array.isArray(newListeners[key]) ? newListeners[key] : [newListeners[key]];
        newArray = newArray.map(function (l) {
          return (
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee(action) {
                var breakCounter, throwIfCalled, breakpoint, response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        breakCounter = (fakeLogic.cache.listenerBreakpointCounter[key] || 0) + 1;
                        fakeLogic.cache.listenerBreakpointCounter[key] = breakCounter;

                        throwIfCalled = function throwIfCalled() {
                          if (fakeLogic.cache.listenerBreakpointCounter[key] !== breakCounter) {
                            throw new Error('kea-listeners breakpoint broke');
                          }
                        };

                        breakpoint = function breakpoint(ms) {
                          if (typeof ms !== 'undefined') {
                            return new Promise(function (resolve) {
                              return setTimeout(resolve, ms);
                            }).then(function () {
                              throwIfCalled();
                            });
                          } else {
                            throwIfCalled();
                          }
                        };

                        _context.prev = 4;
                        _context.next = 7;
                        return l(action.payload, breakpoint, action);

                      case 7:
                        response = _context.sent;
                        _context.next = 14;
                        break;

                      case 10:
                        _context.prev = 10;
                        _context.t0 = _context["catch"](4);

                        if (!(_context.t0.message !== 'kea-listeners breakpoint broke')) {
                          _context.next = 14;
                          break;
                        }

                        throw _context.t0;

                      case 14:
                        return _context.abrupt("return", response);

                      case 15:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[4, 10]]);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }()
          );
        });

        if (logic.listeners[key]) {
          logic.listeners[key] = [].concat(logic.listeners[key], newArray);
        } else {
          logic.listeners[key] = newArray;
        }
      };

      for (var _i = 0, _Object$keys = Object.keys(newListeners); _i < _Object$keys.length; _i++) {
        _loop();
      }
    },
    sharedListeners: function sharedListeners(logic, input) {
      if (!input.sharedListeners) {
        return;
      }

      var newSharedListeners = typeof input.sharedListeners === 'function' ? input.sharedListeners(logic) : input.sharedListeners;
      logic.sharedListeners = _extends({}, logic.sharedListeners || {}, {}, newSharedListeners);
    }
  },
  events: {
    afterPlugin: function afterPlugin() {
      kea.setPluginContext('listeners', {
        byAction: {},
        byPath: {}
      });
    },
    beforeReduxStore: function beforeReduxStore(options) {
      options.middleware.push(function (store) {
        return function (next) {
          return function (action) {
            var response = next(action);

            var _getPluginContext = kea.getPluginContext('listeners'),
                byAction = _getPluginContext.byAction;

            var listeners = byAction[action.type];

            if (listeners) {
              for (var _i2 = 0, _Object$values = Object.values(listeners); _i2 < _Object$values.length; _i2++) {
                var listenerArray = _Object$values[_i2];

                for (var _iterator = listenerArray, _isArray = Array.isArray(_iterator), _i3 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                  var _ref2;

                  if (_isArray) {
                    if (_i3 >= _iterator.length) break;
                    _ref2 = _iterator[_i3++];
                  } else {
                    _i3 = _iterator.next();
                    if (_i3.done) break;
                    _ref2 = _i3.value;
                  }

                  var innerListener = _ref2;
                  innerListener(action);
                }
              }
            }

            return response;
          };
        };
      });
    },
    afterMount: function afterMount(logic) {
      if (!logic.listeners) {
        return;
      }

      addListenersByPathString(logic.pathString, logic.listeners);
    },
    beforeUnmount: function beforeUnmount(logic) {
      if (!logic.listeners) {
        return;
      }

      removeListenersByPathString(logic.pathString, logic.listeners);
    },
    beforeCloseContext: function beforeCloseContext() {
      kea.setPluginContext('listeners', {
        byAction: {},
        byPath: {}
      });
    }
  }
};

function addListenersByPathString(pathString, listeners) {
  var _getPluginContext2 = kea.getPluginContext('listeners'),
      byPath = _getPluginContext2.byPath,
      byAction = _getPluginContext2.byAction;

  byPath[pathString] = listeners;
  Object.entries(listeners).forEach(function (_ref3) {
    var action = _ref3[0],
        listener = _ref3[1];

    if (!byAction[action]) {
      byAction[action] = {};
    }

    byAction[action][pathString] = listener;
  });
}

function removeListenersByPathString(pathString, listeners) {
  var _getPluginContext3 = kea.getPluginContext('listeners'),
      byPath = _getPluginContext3.byPath,
      byAction = _getPluginContext3.byAction;

  Object.entries(listeners).forEach(function (_ref4) {
    var action = _ref4[0],
        listener = _ref4[1];
    delete byAction[action][pathString];

    if (Object.keys(byAction[action]).length === 0) {
      delete byAction[action];
    }
  });
  delete byPath[pathString];
}

module.exports = index;
